import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { PublicFormPage } from '@/pages/record-and-send-public/form/public-form-page';

// TanStack Router parses `?embed=true` as a boolean, so both the boolean and the string are accepted.
const searchSchema = z.object({
	embed: z
		.union([z.boolean(), z.enum(['true', 'false'])])
		.optional()
		.transform((value) => (value === undefined ? undefined : value === true || value === 'true'))
		.catch(undefined),
});

export const Route = createFileRoute('/video/$publicId')({
	validateSearch: searchSchema,
	component: PublicFormPage,
});
